<template>
	<div class="">
		<div class="fram flexCol justb">
			<div class="flexCol alit" style="width: 100%;cursor: pointer;margin-top: 10px;" @click="showModel(1)">
				<div class="flex justb" style="width: 100%;">
					<div class="px-title">产品与供应链管理培训</div>
					<div class="px-num">10,210次</div>
				</div>
				<div class="px-name flex alit justb">
					<div class="flex alit">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%BB%8F%E8%90%A5%E6%9C%8D%E5%8A%A1/%E8%B0%A2%E6%98%8C%E6%97%AD.png"
							alt="" />
						<div class="px-people">谢昌旭</div>
					</div>
					<div class="px-snum flex alit">指导服务次数：<div class="px-snum-desc">
							9986
						</div>
					</div>
				</div>
			</div>
			<div class="flexCol alit" style="width: 100%;margin-top: 5px;cursor: pointer;" @click="showModel(2)">
				<div class="flex justb" style="width: 100%;">
					<div class="px-title">人员能力建设培训</div>
					<div class="px-num">9,210次</div>
				</div>
				<div class="px-name flex alit justb">
					<div class="flex alit">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%BB%8F%E8%90%A5%E6%9C%8D%E5%8A%A1/%E6%9D%8E%E6%98%8A.png"
							alt="" />
						<div class="px-people">李昊</div>
					</div>
					<div class="px-snum flex alit">指导服务次数：<div class="px-snum-desc">
							3786
						</div>
					</div>
				</div>
			</div>
			<div class="flexCol alit" style="width: 100%;margin-top: 5px;cursor: pointer;" @click="showModel(3)">
				<div class="flex justb" style="width: 100%;">
					<div class="px-title">运营指导与技术支持</div>
					<div class="px-num">8,287次</div>
				</div>
				<div class="px-name flex alit justb">
					<div class="flex alit">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%BB%8F%E8%90%A5%E6%9C%8D%E5%8A%A1/%E9%BB%84%E6%95%8F.png"
							alt="" />
						<div class="px-people">黄敏</div>
					</div>
					<div class="px-snum flex alit">指导服务次数：<div class="px-snum-desc">
							2976
						</div>
					</div>
				</div>
			</div>
			<div class="flexCol alit" style="width: 100%;margin-top: 5px;cursor: pointer;margin-bottom: 5px;"
				@click="showModel(3)">
				<div class="flex justb" style="width: 100%;">
					<div class="px-title">专业咨询服务</div>
					<div class="px-num">3,210次</div>
				</div>
				<div class="px-name flex alit justb">
					<div class="flex alit">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%BB%8F%E8%90%A5%E6%9C%8D%E5%8A%A1/%E7%94%98%E7%A7%91%E9%BE%99.png"
							alt="" />
						<div class="px-people">甘科龙</div>
					</div>
					<div class="px-snum flex alit">指导服务次数：<div class="px-snum-desc">
							1082
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style scoped lang="scss">
	.px-num {
		font-weight: 400;
		font-size: 14px;
		color: #B8D3F1;
		font-family: SourceHanSansRegular;
	}

	.px-title {
		font-weight: 400;
		font-size: 14px;
		color: #B8D3F1;
		font-family: SourceHanSansRegular;
	}

	.px-name {
		width: 90%;
		height: 34px;
		background: rgba(0, 40, 108, 0.3);
		border-radius: 8px 8px 8px 8px;
		border: 2px solid rgba(1, 168, 255, 0.3);
		padding: 4px 5%;
		margin-top: 2px;
		font-family: SourceHanSansRegular;

		img {
			width: 30px;
			height: 30px;
			border-radius: 50%;
		}

		.px-snum {
			font-weight: 400;
			font-size: 14px;
			color: #01A8FF;

			.px-snum-desc {
				font-size: 14px;
				color: rgba(155, 199, 75, 1);
				font-family: ddingproSemiBold;
			}
		}

		.px-people {
			font-weight: 400;
			font-size: 16px;
			color: rgba(155, 199, 75, 1);
			margin-left: 10px;
		}
	}
</style>